module.exports = __webpack_public_path__ + "static/media/DFMing-Bd-HK-BF.b97e0a66.svg";